module.exports = __webpack_public_path__ + "static/logo-babf84e5b68d12bd2c651575344437e2.svg";